































































































































import {
  WorkflowFormFieldSubmission,
  WorkflowFormFieldTypeEnum,
  WorkflowFormSubmission,
  IWorkflowFormSectionFieldData,
  IWorkflowFormFieldOptionSubmissionData,
  IWorkflowFormFieldSubmissionData,
  IWorkflowFormSectionData,
  IWorkflowFormSectionSubmissionData,
  IWorkflowFormSectionSubmissionFieldErrorData,
  IWorkflowFormSubmission,
  IWorkflowFormSubmissionData,
  IWorkflowFormTemplateRevisionData,
  WorkflowFormTemplateRevision,
  IWorkflowFormFieldData
} from '@/models';
import { ErrorManager } from '@/models/error';

import { AxiosError } from 'axios';
import { mapActions, mapGetters } from 'vuex';
import { diffDeep } from '@/utils/helpers';
import { cloneDeep } from 'lodash';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

import ALDialog from '../core/Dialog/ALDialog.vue';
import DatePicker from '../common/DatePicker.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import WorkflowFormSubmissionFields from './WorkflowFormSubmissionFields.vue';

export default mixins(auth).extend({
  name: 'WorkflowFormSubmissionDialog',

  components: {
    ALDialog,
    ErrorAlert,
    DatePicker,
    WorkflowFormSubmissionFields
  },

  data() {
    return {
      WorkflowFormFieldTypeEnum,

      dialog: false,
      loading: false,
      isEdit: false,
      isPreview: false,
      isSubmissionFormValid: false,

      sectionPosition: 1,

      errorMessage: '',
      detailErrorMessage: '',

      fieldErrors: [] as IWorkflowFormSectionSubmissionFieldErrorData[],

      workflowFormTemplateRevision: {} as IWorkflowFormTemplateRevisionData,
      workflowFormSubmission: {} as IWorkflowFormSubmissionData,

      answers: [] as IWorkflowFormSectionSubmissionData[]
    };
  },

  computed: {
    ...mapGetters({
      getWorkflowFormTemplateRevisionById:
        'workflowFormTemplate/getWorkflowFormTemplateRevisionById',
      getWorkflowFormSubmissionById:
        'workflowForm/getWorkflowFormSubmissionById'
    }),

    isFormSingleSection(): boolean {
      return (
        this.dialog && this.workflowFormTemplateRevision.sections!.length <= 1
      );
    }
  },

  methods: {
    ...mapActions({
      updateWorkflowFormSubmissionState:
        'workflowForm/updateWorkflowFormSubmissionState',
      createWorkflowFormSubmission: 'workflowForm/createWorkflowFormSubmission',
      updateWorkflowFormSubmission: 'workflowForm/updateWorkflowFormSubmission',
      fetchWorkflowFormSubmission: 'workflowForm/fetchWorkflowFormSubmission'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
      this.fieldErrors = [] as IWorkflowFormSectionSubmissionFieldErrorData[];
    },

    open(
      revision: IWorkflowFormTemplateRevisionData,
      submission?: IWorkflowFormSubmission,
      preview = false
    ) {
      this.clearAllErrors();

      this.isPreview = preview;

      this.workflowFormTemplateRevision = new WorkflowFormTemplateRevision(
        revision
      );

      if (submission) {
        this.workflowFormSubmission = new WorkflowFormSubmission(submission);
      } else {
        //create default instance
        this.workflowFormSubmission = new WorkflowFormSubmission({
          form: {
            workflow: this.workflowFormTemplateRevision.workflow
          } as IWorkflowFormTemplateRevisionData
        });
      }

      this.answers = this.genFormAnswers(
        this.workflowFormTemplateRevision.sections!
      );

      this.isEdit = !!submission;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.sectionPosition = 1;
    },

    addTemplateRow(
      rows: IWorkflowFormFieldSubmissionData[],
      sectionIndex: number
    ) {
      rows.forEach(row => {
        this.answers[sectionIndex].fields.push(row);
      });
    },

    genFormAnswers(
      sections: IWorkflowFormSectionData[]
    ): IWorkflowFormSectionSubmissionData[] {
      const sectionAnswers = [] as IWorkflowFormSectionSubmissionData[];

      sections.forEach((section, i) => {
        sectionAnswers.push({
          fields: [] as IWorkflowFormFieldSubmissionData[]
        });

        section.section_fields!.forEach(section_field => {
          let answers =
            this.workflowFormSubmission.answers?.filter(
              data =>
                (data.field as IWorkflowFormSectionFieldData).id ==
                section_field.id
            ) ?? [];

          if (answers.length === 0) {
            answers = [
              new WorkflowFormFieldSubmission({
                value: '',
                field: section_field,
                option_submissions: [] as IWorkflowFormFieldOptionSubmissionData[],
                template_index: 0
              })
            ];
          } else if (
            (section_field.field_template as IWorkflowFormFieldData).type ==
            WorkflowFormFieldTypeEnum.Checkbox
          ) {
            //TODO: MG- 24-03-2022: Look into why checklist with value object causes bug
            answers = answers.map(answer => {
              answer.option_submissions = (answer.option_submissions as IWorkflowFormFieldOptionSubmissionData[]).map(
                (data: IWorkflowFormFieldOptionSubmissionData) => data.option
              );
              return answer;
            });
          }

          sectionAnswers[i].fields.push(...answers);
        });
      });

      return sectionAnswers;
    },

    //this moves the form to the first section that has an error
    genFieldErrorSectionPosition(): number {
      let sectionPosition = 0;

      this.fieldErrors.forEach((section, i) => {
        if (!sectionPosition) {
          section.errors.forEach(error => {
            if (error) {
              sectionPosition = i + 1;
              return;
            }
          });
        } else {
          return;
        }
      });

      return sectionPosition;
    },

    async updateFormSubmissionData() {
      let answerPayload = [] as IWorkflowFormFieldSubmissionData[];

      let originalFormSubmission = {} as IWorkflowFormSubmissionData;

      let isEditingForm = false;

      if (this.isEdit || this.workflowFormSubmission.id) {
        isEditingForm = true;
      }

      if (isEditingForm) {
        originalFormSubmission = await this.getWorkflowFormSubmissionById(
          this.workflowFormSubmission.id!
        );
      }

      this.answers.forEach((answer, i) => {
        answerPayload = answerPayload.concat(
          answer.fields.map(submission => {
            //this code fixes the bug where a user clears a vselect
            const nullFilterOptions = (submission.option_submissions as IWorkflowFormFieldOptionSubmissionData[]).filter(
              option => option != null
            );

            const options = (nullFilterOptions as IWorkflowFormFieldOptionSubmissionData[]).map(
              (option: IWorkflowFormFieldOptionSubmissionData | number, i) => {
                if (typeof option == 'number') {
                  if (isEditingForm) {
                    const org_submission = originalFormSubmission.answers!.find(
                      org =>
                        (org.field as IWorkflowFormSectionFieldData).id ==
                        (submission.field as IWorkflowFormSectionFieldData).id
                    );

                    if (org_submission) {
                      const org_option = (org_submission.option_submissions as IWorkflowFormFieldOptionSubmissionData[]).find(
                        org_option => org_option.option == option
                      );

                      if (org_option) {
                        return org_option;
                      }
                    }
                  }

                  return { option: option };
                }
                return option;
              }
            );

            return { ...submission, option_submissions: options };
          })
        );
      });

      //when updating form the id of the created answer fields form will need to be
      //correctly mapped to the answerpayload in order to prevent a unique constraint failure
      //of the server
      if (isEditingForm) {
        answerPayload = answerPayload.map((submission, i) => {
          const originalSubmissionAnswer = originalFormSubmission.answers!.find(
            answer =>
              (answer.field as IWorkflowFormSectionFieldData).id ==
              submission.field
          );

          if (!originalSubmissionAnswer) {
            return submission;
          }

          return { ...submission, id: originalSubmissionAnswer.id };
        });
      }

      answerPayload = answerPayload.map(submission => {
        if (typeof submission.field === 'number') return submission;

        submission.field = submission.field.id as number;

        return submission;
      });

      this.workflowFormSubmission = new WorkflowFormSubmission({
        ...this.workflowFormSubmission,
        form: this.workflowFormTemplateRevision.id!,
        answers: answerPayload
      });
    },

    async save() {
      await this.updateFormSubmissionData();

      const formSubmissionPayload = cloneDeep(this.workflowFormSubmission);
      if (this.isEdit || this.workflowFormSubmission.id) {
        const originalFormSubmission = await this.getWorkflowFormSubmissionById(
          formSubmissionPayload.id!
        );

        const formSubmissionDelta = diffDeep(
          this.workflowFormSubmission,
          originalFormSubmission,
          true
        );

        await this.updateWorkflowFormSubmission(formSubmissionDelta);
      } else {
        this.workflowFormSubmission.owner = this.currentUser.id;
        const submissionId = await this.createWorkflowFormSubmission(
          this.workflowFormSubmission
        );

        //update form submission and answers with saved data coming from server.
        this.workflowFormSubmission = this.getWorkflowFormSubmissionById(
          submissionId
        );
        this.answers = this.genFormAnswers(
          this.workflowFormTemplateRevision.sections!
        );

        this.$router.push({
          name: 'workflow-form-request-detail',
          params: {
            templateId: String(this.workflowFormTemplateRevision.id),
            id: submissionId
          }
        });
      }

      //fetch updated checklist and department list from server
      this.$emit('refreshChecklist');
    },

    async saveForm() {
      this.loading = true;
      try {
        await this.save();

        this.loading = false;
        this.close();
      } catch (err) {
        this.loading = false;
        const error = err as AxiosError;
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }

          // Form Model is dynamic and the server returns a diiferent model format for its error
          // therefore I have to map the error data to its correct field.
          if (error.response.data.answers) {
            const submissionFieldErrors = [] as IWorkflowFormSectionSubmissionFieldErrorData[];

            let index = 0;

            this.workflowFormTemplateRevision.sections?.forEach(
              (section, n) => {
                submissionFieldErrors.push({ errors: [] });

                section.section_fields?.forEach(field => {
                  submissionFieldErrors[n].errors.push(
                    error.response!.data.answers[index].detail ?? ''
                  );
                  index++;
                });
              }
            );

            this.fieldErrors = submissionFieldErrors;
            this.sectionPosition = this.genFieldErrorSectionPosition();
          }
        }

        this.errorMessage = ErrorManager.extractApiError(error);
      }
    }
  }
});
